// extracted by mini-css-extract-plugin
module.exports = {"news":"news-1fEl0rQa","news_R":"news_R-19la3l3x","ad_box":"ad_box-3A5sCRNW clearfix","fl":"fl-3-YlAWw- fl","fr":"fr-2UfCjN3u fr","ad":"ad-1hclWNU_"};